import { defineDirectory, DirectoryInstance } from 'best-modules/plugins'
import { DirectoryName } from './types'
import { dataScopeOptions, registrationMarkTypes } from './local'

const {
  DirectoryPlugin,
  fillDirectory,
  getDirectory,
  pushDirectoryItem,
  updateDirectoryItem,
  removeDirectoryItem,
  clearDirectory,
} = defineDirectory<DirectoryName, ''>({
  contractorTypes: '/json/list/contractorTypes',
  addressTypes: '/json/list/addressTypes',
  phoneTypes: '/json/list/phoneTypes',
  emailTypes: '/json/list/emailTypes',
  contractors: '/json/contractor?paginate=false',
  correspondenceTypes: '/json/list/correspondenceTypes',
  correspondenceDocumentTypes: '/json/list/correspondenceDocumentTypes',
  correspondencePriorityTypes: '/json/list/correspondenceDocumentPriorityTypes',
  correspondenceDeliveryTypes: '/json/list/correspondenceDocumentDeliveryTypes',
  correspondenceStatuses: '/json/list/correspondenceStatuses',
  departmentList: '/json/list/departments',
  userList: '/json/list/users',
  orderTypes: '/json/list/orderTypes',
  orderDirections: '/json/list/orderDirections',
  protocolTypes: '/json/list/protocolTypes',
  protocolDirections: '/json/list/protocolDirections',
  roles: '/json/list/roles',
  genders: '/json/list/genders',
  taskStatuses: '/json/list/taskStatuses',
  documentStatuses: {
    url: '/json/list/documentStatuses',
  },
  documentTypes: '/json/list/documentTypes',
  entityList: {
    url: '/json/list/entities',
    indexedKey: 'name',
  },
  absenceTypes: '/json/list/userAbsenceTypes',
  templateRouteAgreements: '/json/list/documentTemplateRouteAgreements',
  templateRouteActions: '/json/list/documentTemplateRouteActions',
  taskTypes: '/json/list/taskTypes',
  taskList: '/json/list/tasks',
  clientAccessLinkTypes: '/json/list/clientAccessLinkTypes',
  caList: '/supportedCertificateAuthority',
  auditTypes: '/json/list/auditTypes',
  riskTypes: '/json/list/riskTypes',
  riskLevels: '/json/list/riskLevels',
  auditRecommendationStatuses: '/json/list/auditRecommendationStatuses',
  auditStatuses: '/json/list/auditStatuses',
  auditControlAssessment: '/json/list/auditInternalControlAssessments',
  templateList: '/json/list/documentTemplates',
  orgDepartmentTypes: '/json/list/orgDepartmentTypes',
  orgPositions: '/json/list/orgPositions',
  orgStaffUnitTypes: '/json/list/orgStaffUnitTypes',
  orgAppointmentTypes: '/json/list/orgAppointmentTypes',
  internalDepartments: '/json/list/internalDepartments',
  activeInternalDepartments: '/json/list/activeInternalDepartments',
  docTypeClasses: '/json/list/docTypeClasses',
  docTypeDefinitions: '/json/list/docTypeDefinitions',
  docTypeFlowTypes: '/json/doc-type/class/flow-types',
  dataScopeOptions: { items: dataScopeOptions },
  auditObjectTypes: '/json/list/auditObjectTypes',
  fieldTypes: '/json/list/fieldTypes',
  fieldDefinitions: '/json/doc-type/field/list-all',
  registrationJournals: '/json/list/registrationJournals',
  maskPlaceholders: '/json/list/maskPlaceholders',
  docTypeRouteTypes: '/json/list/docTypeRouteTypes',
  docTypeRouteStageTypes: '/json/list/docTypeRouteStageTypes',
  docTypeRouteStageCompletionTypes:
    '/json/list/docTypeRouteStageCompletionTypes',
  registrationMarkTypes: { items: registrationMarkTypes },
  documentParticipantResults:
    '/json/list/docTypeDocumentRouteParticipantResults',
  delegationAssignmentTypes: '/json/list/delegationAssignmentTypes',
  delegationRestrictionTypes: '/json/list/delegationRestrictionTypes',
  accessLevelTypes: '/json/list/accessLevelTypes',
  workSchedules: '/json/list/workSchedules',
  workFormats: '/json/list/workFormats',
  documentAcceptanceTypes: '/json/list/docTypeDocumentAcceptanceTypes',
  documentRegistrationTypes: '/json/list/docTypeDocumentRegistrationTypes',
  docTypeFieldEntitySources: '/json/list/docTypeFieldEntitySources',
  incidentStatuses: '/json/list/incidentStatuses',
  incidentPriorities: '/json/list/incidentPriorities',
  incidentTypes: '/json/list/incidentTypes',
  incidentCategories: '/json/list/incidentCategories',
  incidentIssueStatuses: '/json/list/incidentIssueStatuses',
  incidentRiskAssessmentProbabilityLevels:
    '/json/list/incidentRiskAssessmentProbabilityLevels',
})

export default DirectoryPlugin

export {
  fillDirectory,
  getDirectory,
  pushDirectoryItem,
  updateDirectoryItem,
  removeDirectoryItem,
  clearDirectory,
}

declare module '@vue/runtime-core' {
  export interface ComponentCustomProperties {
    $directory: DirectoryInstance<DirectoryName>
  }
}
